module.exports = __webpack_public_path__ + "img/video_en.3fbf25b3.png";